import SaveRow from './row/save';

const { RichText, InnerBlocks } = wp.blockEditor;

const Save = ({ attributes }) => {
  const {
    containerized,
    thead,
    tfoot,
    labels,
    lines,
    columns,
    variant,
    margin,
  } = attributes;

  // Monta o Cabeçalho
  const THead = () => {
    const tHeadCols = [];

    for (let i = 0; i < columns; i++) {
      const text = labels[0]?.columns[i];

      tHeadCols.push(
        <th key={`th-${i}`}>
          <RichText.Content
            tagName="p"
            className={`Typography text center color-blue-dark margin-none`}
            value={text}
          />
        </th>
      );
    }

    return (
      <thead>
        <tr>{tHeadCols}</tr>
      </thead>
    );
  };

  // Monta o Corpo
  const TBody = () => {
    const rows = [];
    for (let i = 0; i < lines; i++) {
      rows.push(
        <SaveRow
          key={`line-${i}`}
          line={i}
          columns={columns}
          attributes={attributes}
        />
      );
    }

    return <tbody>{rows}</tbody>;
  };

  const TFoot = () => {
    // Monta o Rodapé
    const tFootCols = [];
    for (let i = 0; i < columns; i++) {
      const text = labels[1]?.columns[i];

      tFootCols.push(
        <td key={`foot-${i}`}>
          <RichText.Content
            tagName="p"
            className={`Typography text center color-black margin-none`}
            value={text}
          />
        </td>
      );
    }

    return (
      <tfoot>
        <tr>{tFootCols}</tr>
      </tfoot>
    );
  };

  return (
    <div
      className={`
        customTable
        ${margin}
        ${variant}
        ${containerized ? 'Container' : ''}
      `}
    >
      <table
        cellspacing="0"
        cellpadding="0"
        className="customTable-wrap margin-base"
      >
        {thead && <THead />}

        <TBody />

        {tfoot && <TFoot />}
      </table>

      <div className="customTable-actions">
        <InnerBlocks.Content />
      </div>
    </div>
  );
};

export default Save;
